import React from 'react'
import {NavLink} from 'react-router-dom';
import './App.css';

function Navbar() {
    return (
        <>
            <nav class="navbar navbar-expand-lg">
                <NavLink class="navbar-brand" id='brand' href="#">Technical Sanket</NavLink>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav ml-auto">
                        <li class="nav-item">
                            <NavLink class="nav-link" href="#">🎓 BTech ( Computer Science Engineering )</NavLink>
                        </li>
                    </ul>
                    
                </div>
            </nav>
        </>
    )
}

export default Navbar